// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== Contenedor Principal de la Sección ===== */
.Resultados_resultsSection__0pXHv {
  background-color: #000000;
  padding: 60px 5%;
  border-top: 1px solid #333; 
  border-bottom: 1px solid #333;
}

.Resultados_metricsContainer__wGz\\+8 {
  max-width: 1000px;
  margin: 0 auto;
  display: flex;
  justify-content: space-around; 
  align-items: flex-start;
  gap: 40px;
}

/* ===== Estilo de cada Métrica Individual ===== */
.Resultados_metricItem__WZobJ {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.Resultados_metricNumber__2-0Pl {
  font-size: 72px;
  font-weight: 800;
  color: #FF3B00;
  line-height: 1.1;
  margin-bottom: 15px;
}

.Resultados_metricDescription__T3XRw {
  font-size: 16px;
  color: var(--textoBlanco);
  line-height: 1.5;
  max-width: 250px; 
}

/* ======================================= */
/* ===== MEDIA QUERY PARA MÓVILES ===== */
/* ======================================= */
@media (max-width: 767px) {
  .Resultados_resultsSection__0pXHv {
    padding: 50px 5%;
  }
  .Resultados_metricsContainer__wGz\\+8 {
    flex-direction: column; /* Apila los elementos verticalmente */
    align-items: center; /* Centra los elementos apilados */
    gap: 50px; /* Aumenta el espacio vertical entre métricas */
  }
  .Resultados_metricNumber__2-0Pl {
    font-size: 60px;
  }
  .Resultados_metricDescription__T3XRw {
    font-size: 15px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Resultados.module.css"],"names":[],"mappings":"AAAA,mDAAmD;AACnD;EACE,yBAAyB;EACzB,gBAAgB;EAChB,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,6BAA6B;EAC7B,uBAAuB;EACvB,SAAS;AACX;;AAEA,kDAAkD;AAClD;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,4CAA4C;AAC5C,yCAAyC;AACzC,4CAA4C;AAC5C;EACE;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB,EAAE,sCAAsC;IAC9D,mBAAmB,EAAE,kCAAkC;IACvD,SAAS,EAAE,+CAA+C;EAC5D;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* ===== Contenedor Principal de la Sección ===== */\n.resultsSection {\n  background-color: #000000;\n  padding: 60px 5%;\n  border-top: 1px solid #333; \n  border-bottom: 1px solid #333;\n}\n\n.metricsContainer {\n  max-width: 1000px;\n  margin: 0 auto;\n  display: flex;\n  justify-content: space-around; \n  align-items: flex-start;\n  gap: 40px;\n}\n\n/* ===== Estilo de cada Métrica Individual ===== */\n.metricItem {\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.metricNumber {\n  font-size: 72px;\n  font-weight: 800;\n  color: #FF3B00;\n  line-height: 1.1;\n  margin-bottom: 15px;\n}\n\n.metricDescription {\n  font-size: 16px;\n  color: var(--textoBlanco);\n  line-height: 1.5;\n  max-width: 250px; \n}\n\n/* ======================================= */\n/* ===== MEDIA QUERY PARA MÓVILES ===== */\n/* ======================================= */\n@media (max-width: 767px) {\n  .resultsSection {\n    padding: 50px 5%;\n  }\n  .metricsContainer {\n    flex-direction: column; /* Apila los elementos verticalmente */\n    align-items: center; /* Centra los elementos apilados */\n    gap: 50px; /* Aumenta el espacio vertical entre métricas */\n  }\n  .metricNumber {\n    font-size: 60px;\n  }\n  .metricDescription {\n    font-size: 15px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"resultsSection": `Resultados_resultsSection__0pXHv`,
	"metricsContainer": `Resultados_metricsContainer__wGz+8`,
	"metricItem": `Resultados_metricItem__WZobJ`,
	"metricNumber": `Resultados_metricNumber__2-0Pl`,
	"metricDescription": `Resultados_metricDescription__T3XRw`
};
export default ___CSS_LOADER_EXPORT___;
